import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-081b944e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-container" }
const _hoisted_2 = { class: "search-header" }
const _hoisted_3 = { for: "global-search-input" }
const _hoisted_4 = {
  key: 0,
  class: "uk-icon-search"
}
const _hoisted_5 = {
  key: 1,
  class: "uk-icon-spinner"
}
const _hoisted_6 = { class: "results" }
const _hoisted_7 = { class: "group-title" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "icon" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "content" }
const _hoisted_12 = { class: "title" }
const _hoisted_13 = { class: "subtitle" }
const _hoisted_14 = {
  key: 1,
  class: "empty-result"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer" }, " ↑ ↓ to navigate, Enter to select, ⌘ + Enter to open a new window ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    show: _ctx.showing,
    close: () => (_ctx.showing = false),
    "allow-click-out": true,
    "allow-escape": true,
    vanilla: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("label", _hoisted_3, [
            (!_ctx.searching)
              ? (_openBlock(), _createElementBlock("i", _hoisted_4))
              : (_openBlock(), _createElementBlock("i", _hoisted_5))
          ]),
          _withDirectives(_createElementVNode("input", {
            id: "global-search-input",
            ref: "input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyword) = $event)),
            autofocus: "",
            placeholder: "Looking for something?",
            autocomplete: "off"
          }, null, 512), [
            [_vModelText, _ctx.keyword]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (
                        (_ctx.results['Search Results'] &&
                            _ctx.results['Search Results'].length) ||
                        (_ctx.results['Last Visited'] &&
                            _ctx.results['Last Visited'].length)
                    )
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.results, (groupResults, groupName) => {
                return (_openBlock(), _createElementBlock("div", { key: groupName }, [
                  (groupResults.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(groupName), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupResults, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item.subtitle,
                            class: "group-items"
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass([
                                        'item',
                                        {
                                            selected:
                                                _ctx.selectedItem &&
                                                item.subtitle ===
                                                    _ctx.selectedItem.subtitle,
                                        },
                                    ]),
                              onClick: ($event: any) => (_ctx.onClickItem($event, item))
                            }, [
                              _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("img", {
                                  src: `/img/icons/v3/linkicons/${item.icon}.svg`
                                }, null, 8, _hoisted_10)
                              ]),
                              _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, _toDisplayString(item.title), 1),
                                _createElementVNode("div", _hoisted_13, _toDisplayString(item.subtitle), 1)
                              ])
                            ], 10, _hoisted_8)
                          ]))
                        }), 128))
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (!_ctx.keyword)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, "Start typing to search"))
                  : (_openBlock(), _createElementBlock("div", _hoisted_16, "No results found"))
              ]))
        ]),
        _hoisted_17
      ])
    ], undefined, true),
    _: 1
  }, 8, ["show", "close"]))
}